import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import IconComponent from 'ui/src/components/Icon';
import { NewMenuItemSection } from 'ui/src/data/MenuItem';
import twMerge from 'utilities/src/twMerge';

interface MobileMenuLinkSectionProps {
  section: NewMenuItemSection;
}

export default function MobileMenuLinkSection({ section }: MobileMenuLinkSectionProps) {
  const [isShowingLinks, setIsShowingLinks] = useState(!section.title);

  const handleToggleLinks = () => {
    setIsShowingLinks((prev) => !prev);
  };

  return (
    <div className="flex w-full flex-col">
      {section.title && (
        <button
          className={twMerge('flex items-center justify-between', isShowingLinks ? 'mb-4' : '')}
          type="button"
          onClick={handleToggleLinks}
        >
          <span className={twMerge('text-site-neutrals-600 site-paragraph-l font-medium')}>{section.title}</span>

          <IconComponent
            iconName="ExpandMore"
            size="IconM"
            className={twMerge('bg-site-neutrals-800 transition duration-200', isShowingLinks ? 'rotate-180' : '')}
          />
        </button>
      )}

      <AnimatePresence>
        {isShowingLinks && (
          <motion.div
            key={section.id}
            layout
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeIn' }}
            className={twMerge('ml-8 flex flex-col gap-3')}
          >
            {section.links.map((link) => (
              <a
                key={link.id}
                href={link.link_url}
                className="text-site-neutrals-600 site-paragraph-m font-medium transition duration-300 hover:underline hover:brightness-75"
              >
                {link.link_label}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
